import { render, staticRenderFns } from "./canopus.vue?vue&type=template&id=2ca469ab&"
import script from "./canopus.vue?vue&type=script&lang=js&"
export * from "./canopus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType1: require('D:/Project/kpwebsite/PC/components/content/content-type-1.vue').default})
